module.exports = __webpack_public_path__ + "static/media/F-2.84198673.webp";